import React, { FunctionComponent, useContext, useState } from "react";
import { Icon, Modal, ModalBody, TableIconButton, Text } from "@familyzone/component-library";
import { Props as ButtonProps } from "@familyzone/component-library/src/components/Button";
import { ReactRouterCompatContext } from "../components/ContextProvider";
import { InjectedRouter } from "react-router";

interface Props extends Omit<ButtonProps, "variant" | "children"> {
  onClick: (e: React.SyntheticEvent) => void;
  isLoading?: boolean;
  to?: string;
  disabled?: boolean;
  title?: string; // The title
  body?: string; // The modal body
  actionVerb?: string; // Manually set the action verb. Eg, Unarchive, Delete
  iconClass?: string; // Manually set the icon. Eg, fa-refresh, fa-trash-can
}

export const IconButton: FunctionComponent<Props> = ({
  onClick,
  isLoading = false,
  to = undefined,
  disabled = false,
  title = "Unarchive",
  body = "Are you sure you want to unarchive?",
  actionVerb = "Unarchive",
  iconClass = "fa-refresh",
  ...props
}) => {
  const { router } = useContext(ReactRouterCompatContext) as { router: InjectedRouter };
  const [open, setOpen] = useState(false);

  const handleOnOpen = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleOnClose = () => {
    setOpen(false);
  };

  const handlePrimaryCTAClick = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    if (to !== undefined) {
      router.push(to);
    }
    handleOnClose();
    onClick(e);
  };

  return (
    <>
      <TableIconButton
        icon={
          <Icon
            icon={`${iconClass}${isLoading ? " fa-spin" : ""}`}
            data-testid={`${iconClass}${isLoading ? " fa-spin" : ""}`}
            variant="solid"
            color="text.paragraph.light"
          />
        }
        onClick={handleOnOpen}
        aria-label={actionVerb}
        disabled={disabled}
        {...props}
      />
      <Modal
        isOpen={open}
        size="sm"
        onClose={handleOnClose}
        headerText={title}
        variant="danger"
        primaryCTALabel={title}
        onPrimaryCTAClick={handlePrimaryCTAClick}
        secondaryCTALabel="Cancel"
        onSecondaryCTAClick={handleOnClose}
      >
        <ModalBody>
          <Text mb="48px">{body}</Text>
        </ModalBody>
      </Modal>
    </>
  );
};
